import { render } from "./fotito_ingles.vue?vue&type=template&id=cff7b19a&scoped=true"
import script from "./fotito_ingles.vue?vue&type=script&lang=js"
export * from "./fotito_ingles.vue?vue&type=script&lang=js"

import "./fotito_ingles.vue?vue&type=style&index=0&id=cff7b19a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cff7b19a"]])

export default __exports__